import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";

const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Manager", value: "Manager" },
];

const departmentOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Quality Control", value: "QUALITY CONTROL" },
  { label: "Production", value: "PRODUCTION" },
  { label: "Packing", value: "PACKING" },
  { label: "Cutting", value: "CUTTING" },
  { label: "Quality", value: "QUALITY" },
];

const data = [
{sno: 1, empNo: "0", empName: "AES ADMIN", department: "Admin", category: "Admin",dob: "03.04.24", doj: "03.04.24", status: "Active"},
{sno: 2, empNo: "001", empName: "ARUN", department: "QUALITY CONTROL", category: "Staff",dob: "13.06.89", doj: "01.01.24", status: "Active"},
{sno: 3, empNo: "002", empName: "VIGNESH", department: "PRODUCTION", category: "Staff",dob: "15.07.92", doj: "01.01.24", status: "Active"},
{sno: 4, empNo: "003", empName: "ULAGURAJ", department: "PACKING", category: "Manager",dob: "16.07.85", doj: "01.01.24", status: "Active"},
{sno: 5, empNo: "00320", empName: "NAVEEN", department: "PACKING", category: "Manager",dob: "11.07.84", doj: "09.10.24", status: "Active"},
];

const columns = [
  { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
  { Header: "EmpNo", accessor: "empNo" },
  { Header: "EmpName", accessor: "empName" },
  { Header: "DepartmentName", accessor: "department" },
  { Header: "EmpCategory", accessor: "category" },
  { Header: "DOB", accessor: "dob" },
  { Header: "DOJ", accessor: "doj" },
  { Header: "Status", accessor: "status", },
];

const RecruitmentReportNewJoinee = () => {
  const formik = useFormik({
    initialValues: {
      fromDate: null,
      toDate: null,
      department: null,
      category: null,
    },
    validationSchema: Yup.object({
      fromDate: Yup.date().required("From Date is required"),
      toDate: Yup.date().required("To Date is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Recruitment" breadcrumbItem="New Joinee" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col xl={3} md={6}>
                  <Label>From Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="fromDate"
                    selected={formik.values.fromDate}
                    onChange={date => formik.setFieldValue("fromDate", date)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate ? (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  ) : null}
                </Col>
                <Col xl={3} md={6}>
                  <Label>To Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="toDate"
                    selected={formik.values.toDate}
                    onChange={date => formik.setFieldValue("toDate", date)}
                  />
                  {formik.touched.toDate && formik.errors.toDate ? (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  ) : null}
                </Col>
                <Col xl={3} md={6}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={val => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col xl={3} md={6}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={val => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col xl={12} className="d-flex justify-content-end gap-2 mob-center flex-wrap">
                  <Button type="submit" className="btn button-search"><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" className="btn button-print"><i className="fas fa-print me-1" /> Print</Button>
                  <Button type="button" className="btn button-export"><i className="fas fa-file-export me-1" /> Export</Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default RecruitmentReportNewJoinee;
